export class MenuModel {
  public open = false;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/menu/menuModel.tsx